import { render, staticRenderFns } from "./UserRiskMonitor.vue?vue&type=template&id=14a3121a&scoped=true"
import script from "./UserRiskMonitor.vue?vue&type=script&lang=js"
export * from "./UserRiskMonitor.vue?vue&type=script&lang=js"
import style0 from "./UserRiskMonitor.vue?vue&type=style&index=0&id=14a3121a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a3121a",
  null
  
)

export default component.exports